import React from 'react';
import { puckFixedAspectRatioField } from '../../../media/mediaPuckFields';
import { Text } from '@mantine/core';
import ImageComparisonBlock from './ImageComparisonBlock';
import { IMAGE_COMPARISON_STYLE_SCHEMA } from './imageComparisonStyleSchema';
import { styleDefaults } from '../../../../shared/theme/styleSchema';
import { BORDERLESS_BORDER } from '../../../../shared/boxes/borderStyles';
import { puckImageField } from '../../../puck/fields/puckImageField';
import { puckThemeStyleField } from '../../../puck/fields/ThemeStyleSelectField';
import { puckSectionField, puckStyleGallerySectionField } from '../../../puck/fields/puckSectionField';
import { puckColorField, puckPrimaryColorField } from '../../../puck/fields/createPuckColorField';
import { puckBorderField } from '../../../puck/fields/puckBorderField';
import { puckShadowField } from '../../../puck/fields/puckShadowField';
import { puckTextRolesField } from '../../../puck/fields/TextRolesField';
import { puckPxSpacingField } from '../../../puck/fields/puckPxSpacingField';
import { withThemedFieldValues } from '../../../puck/fields/themedFieldValues';
import { themedBlockProps, themedBlockResolveData, themedBlockResolveFields } from '../../../puck/themedBlocks';

const imageComparisonConfig = {
  label: 'Comparateur avant/après',
  defaultProps: { beforeSrc: '', afterSrc: '', beforeLabel: 'Avant', afterLabel: 'Après', ...styleDefaults(IMAGE_COMPARISON_STYLE_SCHEMA) },
  fields: withThemedFieldValues('imageComparison', {
    _content: puckSectionField('Images'),
    _help: { type: 'custom', render: () => <Text size="xs">Le visiteur fait glisser la poignée pour passer de l’image avant à l’image après. Faites la même chose sur la page pour vérifier le cadrage ; les libellés se modifient directement sur l’image.</Text> },
    beforeSrc: puckImageField('Image avant', { focalPointProp: 'beforeFocalPoint' }),
    beforeAlt: { type: 'text', label: 'Description accessible avant' },
    afterSrc: puckImageField('Image après', { focalPointProp: 'afterFocalPoint' }),
    afterAlt: { type: 'text', label: 'Description accessible après' },
    _gallery: puckStyleGallerySectionField('Comparateur'),
    themeStyleId: puckThemeStyleField('imageComparison'),
    _style: puckSectionField('Présentation'),
    ratio: puckFixedAspectRatioField(),
    labelBackground: puckColorField('Fond des libellés', { allowTransparent: true }),
    accent: puckPrimaryColorField('Couleur de la poignée'),
    handleSize: puckPxSpacingField('Taille de la poignée'),
    border: puckBorderField('Cadre', { readDefaults: () => BORDERLESS_BORDER }),
    shadow: puckShadowField('Ombre'),
    textStyles: puckTextRolesField([{ key: 'label', label: 'Libellés', defaultColor: '#ffffff' }]),
  }),
  resolveData: themedBlockResolveData('imageComparison'),
  resolveFields: themedBlockResolveFields('imageComparison'),
  render: (props) => <ImageComparisonBlock {...themedBlockProps('imageComparison', props, props.puck?.metadata)} />,
};

export default imageComparisonConfig;
